import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "interaction d-flex flex-column justify-content-center mt-5 text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "informative" }, " Make your own Lollapalooza line-up based on your Spotify top artists!!! ", -1)
const _hoisted_3 = { class: "mt-5" }

import SpotifyLogin from '@/components/SpotifyLogin.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(SpotifyLogin)
    ])
  ]))
}
}

})